<div #htmlDiv [style.font-family]="'Poppins'" class="htmlInner" [innerHtml]="(item.config['notes']| sanitizeHtml) ||''"></div>